export const curriculumPreviewModules = [
  {
    vimeoProjectId: "29119340",
    title: "EQ Types",
    position: 1,
    lessons: [
      { vimeoVideoId: "1188978172", title: "01.How EQ Can Make or Break Your Vocals", duration: 13 },
      { vimeoVideoId: "1188978202", title: "02.Parametric EQ  Your Main Weapon for Vocal Clarity", duration: 485 },
      { vimeoVideoId: "1188978320", title: "03.Graphic EQ Explained (When & Why to Use It)", duration: 297 },
      { vimeoVideoId: "1188978401", title: "04.Parametric vs Graphic EQ  Which One Actually Matters", duration: 63 },
      { vimeoVideoId: "1188978461", title: "05.Shelf EQ  Add Air & Remove Mud Instantly", duration: 77 },
      { vimeoVideoId: "1188978498", title: "06. Dynamic EQ  Fix Problems Without Killing the Vocal", duration: 68 },
      { vimeoVideoId: "1188978538", title: "07.Analog-Style EQ  Add Warmth & Character", duration: 88 },
    ],
    subtopics: [],
  },
  {
    vimeoProjectId: "29119399",
    title: "Compressor Complete Guide",
    position: 2,
    lessons: [
      { vimeoVideoId: "1188979061", title: "01.Why Your Vocals Still Sound Amateur (Compressor Fix)", duration: 16 },
      { vimeoVideoId: "1188979093", title: "02.Why Compressor Is the Secret to Pro Vocals", duration: 86 },
      { vimeoVideoId: "1188979137", title: "03.Understand Compressor Without Confusion (Attack, Release, Ratio)", duration: 546 },
      { vimeoVideoId: "1188979237", title: "04.Watch Me Fix a Raw Vocal Using Compressor", duration: 304 },
      { vimeoVideoId: "1188979301", title: "05.LA-2A Style Compressor  Smooth & Musical Control", duration: 75 },
      { vimeoVideoId: "1188979343", title: "06.Serial Compression  The Pro Trick for Consistent Vocals", duration: 178 },
      { vimeoVideoId: "1188979416", title: "07. Compressor Types That Actually Matter (Part 1)", duration: 90 },
      { vimeoVideoId: "1188979467", title: "08. Choosing the Right Compressor for Your Vocal (Part 2)", duration: 173 },
      { vimeoVideoId: "1188979521", title: "09.Parallel Compression  Make Vocals Thick Without Killing Dynamics", duration: 248 },
    ],
    subtopics: [],
  },
  {
    vimeoProjectId: "29123084",
    title: "Preparing Vocals for the Mix",
    position: 3,
    lessons: [
      { vimeoVideoId: "1189063639", title: "01. Welcome  What Youll Fix in Your Vocals After This", duration: 20 },
      { vimeoVideoId: "1189063683", title: "02.Fix Vocal Levels Without Compression (Clip Gain Secrets)", duration: 78 },
      { vimeoVideoId: "1189063746", title: "03.Clean Up Breaths Without Killing Emotion", duration: 190 },
      { vimeoVideoId: "1189063823", title: "04.Control Breaths Like a Pro (Not Remove, Control)", duration: 104 },
      { vimeoVideoId: "1189063867", title: "05.Fix Harsh S Sounds Before Mixing (Sibilance Control)", duration: 100 },
      { vimeoVideoId: "1189063928", title: "06.Remove Background Noise Without Ruining Quality", duration: 74 },
      { vimeoVideoId: "1189063985", title: "07.Why Your Vocals Sound Bad (Headroom Mistakes Explained)", duration: 45 },
      { vimeoVideoId: "1189064056", title: "08.Surgical EQ  Remove Mud, Boxiness & Harshness", duration: 142 },
      { vimeoVideoId: "1189064115", title: "09.Fix Whistles, Ringing & Annoying Frequencies", duration: 236 },
    ],
    subtopics: [],
  },
  {
    vimeoProjectId: "29123108",
    title: "Vocal Balance & Control",
    position: 4,
    lessons: [
      { vimeoVideoId: "1189064483", title: "01.Why Your Vocals Dont Sit in the Mix (Tonal EQ Fix)", duration: 37 },
      { vimeoVideoId: "1189064553", title: "02.Additive EQ  Make Your Vocals Shine & Pop", duration: 35 },
      { vimeoVideoId: "1189064606", title: "03.Clean Before You Boost (Subtractive EQ Workflow)", duration: 39 },
      { vimeoVideoId: "1189064643", title: "04.Understand Vocal Frequencies (Where Everything Lives)", duration: 1057 },
      { vimeoVideoId: "1189064831", title: "05.EQ Targets  Make Vocals Fit Any Beat", duration: 67 },
      { vimeoVideoId: "1189064952", title: "06.Why Reference Tracks = Faster, Better Mixes", duration: 347 },
      { vimeoVideoId: "1189065077", title: "07.How to Use Reference Tracks While Mixing (Step-by-Step)", duration: 285 },
      { vimeoVideoId: "1189065187", title: "08.Before vs After  Fix Your Mix Using Reference Tracks", duration: 54 },
    ],
    subtopics: [],
  },
  {
    vimeoProjectId: "29123152",
    title: "Vocal Tone & Color",
    position: 5,
    lessons: [
      { vimeoVideoId: "1189065748", title: "01.intro to saturator", duration: 20 },
      { vimeoVideoId: "1189065797", title: "02.What is saturation", duration: 31 },
      { vimeoVideoId: "1189065870", title: "03.What is ODD and EVEN harmonics", duration: 169 },
      { vimeoVideoId: "1189065953", title: "04.how to check odd or even harmonic", duration: 239 },
      { vimeoVideoId: "1189066038", title: "05.types of saturation", duration: 114 },
      { vimeoVideoId: "1189066084", title: "06. saturation on vocals", duration: 231 },
      { vimeoVideoId: "1189066168", title: "07.whats the right way to use saturation", duration: 113 },
      { vimeoVideoId: "1189066241", title: "08.Vintage Saturation plugin", duration: 94 },
      { vimeoVideoId: "1189066329", title: "09.Listening to reference track", duration: 106 },
      { vimeoVideoId: "1189066455", title: "10.how to Implimenting the reference track to your project", duration: 206 },
      { vimeoVideoId: "1189066528", title: "11.final Conclution about saturation and colouring the vocals", duration: 33 },
    ],
    subtopics: [],
  },
  {
    vimeoProjectId: "29123206",
    title: "SPACE & FX (ADVANCED)",
    position: 6,
    lessons: [],
    subtopics: [
      {
        vimeoProjectId: "29123213",
        title: "01.Delay",
        position: 1,
        lessons: [
          { vimeoVideoId: "1189067408", title: "01.Intro", duration: 14 },
          { vimeoVideoId: "1189067460", title: "02.Delay Basics  What Actually Matters", duration: 264 },
          { vimeoVideoId: "1189067542", title: "03.Set Feedback Without Messing Up Your Mix", duration: 120 },
          { vimeoVideoId: "1189067613", title: "04.Why Too Much Feedback Ruins Your Mix", duration: 40 },
          { vimeoVideoId: "1189067655", title: "05.Delay Modulation  Add Movement & Width", duration: 11 },
          { vimeoVideoId: "1189067699", title: "06.EQ Your Delay  Clean & Professional Sound", duration: 74 },
          { vimeoVideoId: "1189067757", title: "07.Dry vs Wet  Balance Delay Like a Pro", duration: 50 },
          { vimeoVideoId: "1189067816", title: "08.Slapback Delay  Instant Vocal Thickness", duration: 258 },
          { vimeoVideoId: "1189067915", title: "09.Build a Pro Slapback Delay Chain", duration: 91 },
          { vimeoVideoId: "1189067995", title: "10.Pro Delay Settings (Works on Any Plugin)", duration: 80 },
          { vimeoVideoId: "1189068046", title: "11.Delay Throws  Pro Trick for Transitions", duration: 149 },
          { vimeoVideoId: "1189068099", title: "12.Breakdown Bollywood Delay Throw Style", duration: 216 },
          { vimeoVideoId: "1189068184", title: "13.Build Your Own Delay Throw (Step-by-Step)", duration: 103 },
          { vimeoVideoId: "1189068250", title: "14.Ping Pong Delay  Create Width Instantly", duration: 114 },
          { vimeoVideoId: "1189068342", title: "15. Automation  Make Delay Move with the Song", duration: 65 },
          { vimeoVideoId: "1189068419", title: "16.Advanced Delay Automation Tricks", duration: 252 },
          { vimeoVideoId: "1189068533", title: "17.Where to Use Delay (Not Everywhere!)", duration: 79 },
          { vimeoVideoId: "1189068623", title: "18.Create Your Signature Delay Chain", duration: 141 },
          { vimeoVideoId: "1189068693", title: "19.Hidden Delay Tricks Used by Pros", duration: 45 },
          { vimeoVideoId: "1189068765", title: "20.Quarter Note Delay  When & How to Use It", duration: 99 },
          { vimeoVideoId: "1189068824", title: "21.Manual Delay  Total Control Technique", duration: 126 },
          { vimeoVideoId: "1189068894", title: "22.Use Delay to Push Vocals Back (Depth Control)", duration: 63 },
          { vimeoVideoId: "1189068998", title: "23.Match Delay Style to Genre (Dont Mix Blindly)", duration: 74 },
        ],
        subtopics: [],
      },
      {
        vimeoProjectId: "29123330",
        title: "02.Reverb",
        position: 2,
        lessons: [
          { vimeoVideoId: "1189070149", title: "01.intro", duration: 22 },
          { vimeoVideoId: "1189070206", title: "02.Types of Reverb", duration: 310 },
          { vimeoVideoId: "1189070297", title: "03.Set Pre-Delay & Decay for Clean, Professional Space", duration: 149 },
          { vimeoVideoId: "1189070350", title: "04.Damping  Control Harsh & Muddy Reverb", duration: 151 },
          { vimeoVideoId: "1189070425", title: "05.Reverb Size  Small vs Big (What to Choose)", duration: 145 },
          { vimeoVideoId: "1189070502", title: "06.Diffusion  Smooth vs Grainy Reverb Sound", duration: 166 },
          { vimeoVideoId: "1189070587", title: "07.Modulation  Add Movement to Your Reverb", duration: 47 },
          { vimeoVideoId: "1189070645", title: "08.EQ Your Reverb  Stop Mud & Harshness", duration: 105 },
          { vimeoVideoId: "1189070695", title: "09.Reverb Modes  Choose the Right Space", duration: 71 },
          { vimeoVideoId: "1189070743", title: "10.Convolution Reverb  Real Spaces in Your Mix", duration: 87 },
          { vimeoVideoId: "1189070796", title: "11.Story Behind Convolution Reverb", duration: 76 },
          { vimeoVideoId: "1189070865", title: "12.Use Convolution Reverb for Realistic Vocals", duration: 132 },
          { vimeoVideoId: "1189070945", title: "13.Pro Tricks with Convolution Reverb (IR-Based Mixing)", duration: 199 },
          { vimeoVideoId: "1189071063", title: "14.Plate Reverb  The Secret to Vocal Shine", duration: 415 },
          { vimeoVideoId: "1189071211", title: "15.Plate Variations  Choose Your Flavor", duration: 163 },
          { vimeoVideoId: "1189071304", title: "16.Choose the Right Reverb for Any Song", duration: 190 },
          { vimeoVideoId: "1189071360", title: "17. Use Reference Tracks to Match Reverb Style", duration: 60 },
          { vimeoVideoId: "1189071409", title: "18.Copy Pro Reverb Settings Using References", duration: 375 },
          { vimeoVideoId: "1189071551", title: "19.Creative Reverb Tricks (Make Your Mix Stand Out)", duration: 28 },
          { vimeoVideoId: "1189071587", title: "20.Breakdown Bollywood Vocal Reverb Style", duration: 214 },
          { vimeoVideoId: "1189071728", title: "21.Recreate Bollywood-Style Reverb (Step-by-Step)", duration: 48 },
          { vimeoVideoId: "1189071780", title: "22.Final Reverb Workflow (Step-by-Step Recap)", duration: 23 },
        ],
        subtopics: [],
      },
    ],
  },
  {
    vimeoProjectId: "29123445",
    title: "Background Vocals",
    position: 7,
    lessons: [
      { vimeoVideoId: "1189072500", title: "01.Intro", duration: 13 },
      { vimeoVideoId: "1189072546", title: "02.Doubler Explained  Instant Vocal Width", duration: 78 },
      { vimeoVideoId: "1189072600", title: "03.Use Doubler Without Phase Issues", duration: 183 },
      { vimeoVideoId: "1189072689", title: "04.Vocal Harmonies  Add Depth & Emotion", duration: 547 },
      { vimeoVideoId: "1189072855", title: "05.When to Use Harmonies (Dont Overdo It)", duration: 121 },
      { vimeoVideoId: "1189072926", title: "06.Match Vocal Layers to the Song Style", duration: 13 },
      { vimeoVideoId: "1189072955", title: "07.Use Reference Tracks for Width & Layers", duration: 57 },
      { vimeoVideoId: "1189073021", title: "08. Blend Multiple Vocal Layers Like a Pro", duration: 137 },
      { vimeoVideoId: "1189073098", title: "09.Fix Layering at Recording Stage (Not in Mix)", duration: 81 },
      { vimeoVideoId: "1189073179", title: "10.FX Template", duration: 113 },
    ],
    subtopics: [],
  },
  {
    vimeoProjectId: "29123586",
    title: "Bonus Class",
    position: 8,
    lessons: [
      { vimeoVideoId: "1189075239", title: "Final Vocal Mix", duration: 880 },
    ],
    subtopics: [],
  },
];
